var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLength(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_96)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1576 5.22694L12.7057 6.76925L12.9376 7.00006L12.7057 7.23122L11.1576 8.77319L10.6983 8.31122L11.6864 7.32699L2.3133 7.32699L3.30166 8.31122L2.8421 8.77319L1.29393 7.23122L1.06208 7.00006L1.29393 6.76925L2.8421 5.22694L3.30166 5.68891L2.3133 6.67314L11.6864 6.67314L10.6983 5.68891L11.1576 5.22694ZM0.653166 3.2447L0.653165 10.7554L-0.000344605 10.7554L-0.000344276 3.2447L0.653166 3.2447ZM14 3.24471L14 10.7554L13.3468 10.7554L13.3468 3.24471L14 3.24471Z",
    fill: "#3CBD96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_96"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(14) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLength);
export default __webpack_public_path__ + "static/media/length.b52304d030912770c01c13f487a5d303.svg";
export { ForwardRef as ReactComponent };